import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { ADMIN_COMMERCIAL_FEATURES_QUERY_KEY } from '@/state/queries/admin/use-admin-commercial-features-query';

export function useDeleteCommercialFeatureMutation() {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const token = await getToken();
      await sendJSONRequest({
        url: `${import.meta.env.VITE_API_URL}/commercial-features/${id}`,
        method: METHOD.DELETE,
        token: token ?? '',
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [ADMIN_COMMERCIAL_FEATURES_QUERY_KEY] });
    },
  });
}
